export default "__VITE_ASSET__BXk6HFts__"